import { createFileRoute, Link } from '@tanstack/react-router';
import { getAllianceDuelStatus, getArmsRaceNext, getWantedBossNext } from '../../lib/eventStatus';

const events = [
  {
    id: 'arms-race',
    title: 'Arms Race',
    description: 'Daily 4-hour themes rotating all week. Earn points and badges toward ranking rewards.',
    status: getArmsRaceNext,
    to: '/events/arms-race',
    cta: 'View schedule',
  },
  {
    id: 'wanted-boss',
    title: 'Wanted Boss',
    description: 'Boss spawns Mon/Thu at 00:00/06:00/12:00/18:00 (server). Tank heroes +50% damage.',
    status: getWantedBossNext,
    to: '/events/wanted-boss',
    cta: 'View spawn times',
  },
  {
    id: 'alliance-duel',
    title: 'Alliance Duel',
    description: 'Week-long alliance vs alliance duel. Daily themes, individual and alliance rewards.',
    status: getAllianceDuelStatus,
    to: '/events/alliance-duel',
    cta: 'View rules & scoring',
  },
];

export const Route = createFileRoute('/events/')({
  component: EventsPage,
});

function EventsPage() {
  return (
    <section className="section">
      <div className="container">
        <h1 className="section-title">Alliance Events</h1>
        <p className="text-center text-text-secondary max-w-3xl mx-auto leading-relaxed">
          Browse current alliance events. Each card shows the next window or current status and links to full details.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 mt-10">
          {events.map((event) => {
            const status = event.status();
            return (
              <div
                key={event.id}
                className="bg-bg-card border border-border rounded-xl p-6 flex flex-col gap-4 transition-all duration-300 hover:-translate-y-1 hover:border-primary hover:shadow-glow"
              >
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <h2 className="font-orbitron text-2xl text-primary-light mb-2">{event.title}</h2>
                    <p className="text-text-secondary">{event.description}</p>
                  </div>
                  <span className="px-3 py-1 rounded-full text-xs uppercase tracking-wide bg-primary/10 text-primary-light border border-primary/40">
                    Active
                  </span>
                </div>
                <div className="bg-bg-darker border border-border rounded-lg p-4">
                  <div className="font-orbitron text-lg text-text-primary">{status.label}</div>
                  {status.sublabel && <div className="text-text-muted text-sm mt-1">{status.sublabel}</div>}
                </div>
                <div className="mt-auto">
                  <Link
                    to={event.to}
                    className="btn btn-primary w-full text-center block"
                  >
                    {event.cta}
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}



